import {debounce, getMobileOS} from './Utils';

const $ = jQuery;

export default class Navigation {
    constructor() {
        this.$content = $('#content');
        this._isFixed = false;
        this.availableHeight = 0;
        this.hoverTimeout = null;
        this.timeoutDelay = 1000;
        this.offset = 40;
        this.elementsOffset = 122;

        $(window)
            .on('scroll', debounce(() => this._onScroll(), 10))

        $('body').on('click','.menu__toggle', (e) => this._onCheckedClick(e))
            .on('mouseenter','.menu__item--0', (e) => this._onHover(e))
            .on('mousemove','.menu__item--0', (e) => this._clearTimeout(e))
            .on('mouseleave','.menu__item--0', (e) => this._setTimeout(e));
    }
    _onScroll() {
        let $win = $(window),
            $nav = $('.menu'),
            $header = $('.header'),
            $carousel = $('.carousel');

        if ($win.scrollTop() >= ($header.height() + $carousel.height() + $nav.height() + 30) ) {
            $nav.addClass('menu--fixed');
        } else {
            $nav.removeClass('menu--fixed');
        }
    }
    _onCheckedClick(e) {
        let $radio = $(`#${$(e.currentTarget).prop('for')}`);
        if ($radio.is(':checked')){
            $radio.removeAttr('checked');
            return false;
        }
    }
    _onHover(e) {
        let $toggle = $(e.currentTarget).find('.menu__toggle');
        if ($toggle.length < 1 || getMobileOS() !== 'unknown') {
            return;
        }
        let $radio = $(`#${$toggle.prop('for')}`);
        $radio.prop('checked', true);
        this._setTimeout();
    }
    _clearTimeout(e) {
        if (this.hoverTimeout) {
            clearTimeout(this.hoverTimeout);
        }
    }
    _setTimeout(e) {
        this._clearTimeout();
        this.hoverTimeout = setTimeout(() => this._onHoverTimeout(),this.timeoutDelay);
    }
    _onHoverTimeout() {
        let $radio = $('.menu__toggler:checked');
        $radio.removeAttr('checked');
    }
}



// WEBPACK FOOTER //
// ./app/themes/template/res/js/src/modules/Navigation.js